module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.bb203971.svg";